import PropTypes from 'prop-types';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import formatTravelMode from '../../../../helpers/formatTravelMode';
import ConfirmModal from '../../../ConfirmModal';
import MarkdownToHtml from '../../../MarkdownToHtml';
import { TravelTypes } from '../../../../constants';

const ChangeBookingConfirmModal = ({
  onCancel,
  onConfirm,
  mode,
  cancellationPolicy,
  carrierFullName,
}) => {
  const { travelAgency } = useSelector((store) => store.user);
  const { tripConfirmation } = useSelector((store) => store.trip);
  const isNdcFare = Boolean(
    _.get(_.find(tripConfirmation && tripConfirmation.bookingResponses, 'orderId'), 'orderId'),
  );
  const serviceFees = travelAgency &&
    travelAgency.settings &&
    travelAgency.settings.defaultConditionsAndPolicy && (
      <div className="mt-4">
        <MarkdownToHtml
          content={travelAgency.settings.defaultConditionsAndPolicy}
          className="text-black"
        />
      </div>
    );

  const messages =
    travelAgency && travelAgency.settings && travelAgency.settings.tripConfirmationMessages;
  let ndcMessage = '';
  if (messages && isNdcFare) {
    ndcMessage = messages.changeNDCFlight;
  }

  let message = null;
  if (!_.isEmpty(ndcMessage) && mode === TravelTypes.flight && !_.isEmpty(carrierFullName)) {
    message = (
      <MarkdownToHtml
        content={ndcMessage.replace('{{airlineName}}', carrierFullName)}
        className="text-black"
      />
    );
  } else {
    message = (
      <>
        <div>
          <strong>Note:</strong> Once we successfully book your new {formatTravelMode(mode)}, your
          previously booked {formatTravelMode(mode)} rate will be cancelled, and its cancellation
          policy will still apply. You must review the cancellation policy of your currently booked{' '}
          {formatTravelMode(mode)} rate before proceeding to change this {formatTravelMode(mode)}{' '}
          booking.
        </div>
        {serviceFees}
        {cancellationPolicy && (
          <>
            <br />
            <b>Cancellation policy of booked {formatTravelMode(mode)}:</b>
            <div>{cancellationPolicy}</div>
          </>
        )}
      </>
    );
  }
  return (
    <ConfirmModal
      onCancel={onCancel}
      onConfirm={onConfirm}
      okButtonLabel="I reviewed the cancellation policy"
      cancelButtonLabel="Go back"
      event={`Trip confirmation - Change ${formatTravelMode(mode)} click`}
      message={message}
    />
  );
};

ChangeBookingConfirmModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  mode: PropTypes.number.isRequired,
  cancellationPolicy: PropTypes.string,
  carrierFullName: PropTypes.string,
};

ChangeBookingConfirmModal.defaultProps = {
  cancellationPolicy: undefined,
  carrierFullName: undefined,
};

export default ChangeBookingConfirmModal;
